import { colorScheme } from "nativewind";
import { useSyncExternalStore } from "react";

/** Re-reads on each change, since NativeWind only subscribes to the observables a read reaches. */
function subscribe(onChange: () => void) {
  const effect = {
    dependencies: new Set<() => void>(),
    run: () => {
      unsubscribe();
      colorScheme.get(effect);
      onChange();
    },
  };
  const unsubscribe = () => {
    for (const remove of effect.dependencies) remove();
    effect.dependencies.clear();
  };
  colorScheme.get(effect);
  return unsubscribe;
}

/**
 * NativeWind's colour scheme and its setter. Use this, never NativeWind's own `useColorScheme`.
 *
 * NativeWind's hook subscribes during render and never unsubscribes, so a render React discards
 * (expo-router prerendering a lazy route behind Suspense) leaves a listener behind, and the next
 * theme change sets state on a component that never mounted: React's "state update on a component
 * that hasn't mounted yet" warning (TRO-2083). `useSyncExternalStore` subscribes only on commit.
 */
export function useColorScheme() {
  return {
    colorScheme: useSyncExternalStore(subscribe, () => colorScheme.get()),
    setColorScheme: (next: "light" | "dark" | "system") => colorScheme.set(next),
  };
}
